import { render, staticRenderFns } from "./AlertRowMobile.vue?vue&type=template&id=d738fde6&scoped=true&"
import script from "./AlertRowMobile.vue?vue&type=script&lang=ts&"
export * from "./AlertRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./AlertRowMobile.vue?vue&type=style&index=0&id=d738fde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d738fde6",
  null
  
)

export default component.exports